import 'css-chunksrc/client/pages/zonesPage/reportsPage/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_6g0ba_1",
  "input": "_input_6g0ba_10",
  "indicator": "_indicator_6g0ba_1",
  "name": "_name_6g0ba_27"
};